import { render, staticRenderFns } from "./ElisButton.vue?vue&type=template&id=c6d877ba&scoped=true"
import script from "./ElisButton.vue?vue&type=script&lang=js"
export * from "./ElisButton.vue?vue&type=script&lang=js"
import style0 from "./ElisButton.vue?vue&type=style&index=0&id=c6d877ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d877ba",
  null
  
)

export default component.exports